(() => {
  let opener;
  let previousOverflow;
  const dialog = document.getElementById('GreenleafLegalNotice');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-gl-legal-notice]');
    if (!trigger || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    opener = trigger;
    if (!dialog.open) {
      previousOverflow = document.documentElement.style.overflow;
      dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
      const body = dialog.querySelector('.gl-legal-notice__body');
      body.scrollTop = 0;
      body.scrollLeft = 0;
    }
  });
  dialog.querySelector('[data-gl-legal-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => {
    document.documentElement.style.overflow = previousOverflow || '';
    if (opener && opener.isConnected) opener.focus({ preventScroll: true });
  });
})();
